module.exports = __webpack_public_path__ + "img/mtt_3.3.d3720e99.png";